import { $, $$, getTopPosition } from 'utils/dom';
import Bus from 'modules/event-bus';
import Shower from 'modules/shower';
import AniScroll from 'modules/ani-scroll';

const history = window.history;

class Jumpmarks {
  constructor(props) {
    this.container = props.container;
    this.target = props.target;
    this.height = props.height;
    this.showerHandler = props.showerHandler;
    this.showerTarget = props.showerTarget;
    this.itemsButtons = props.itemsButtons;
    this.shower = null;
    this.showerAlreadyInited = false;
    this.detectScroll = props.detectScroll || false;
    this.offset = props.offset || 0;
    this.dropdown = props.dropdown || false;
  }

  toggleDropdown = () => {
    if (this.target.offsetHeight > this.height) {
      this.container.classList.add('drop-down');
      if (this.shower && !this.showerAlreadyInited) {
        this.shower.init();
        this.showerAlreadyInited = true;
      }
    }
  };

  initShower = () => {
    if (this.showerHandler && this.showerTarget) {
      const target = this.showerTarget;
      const handler = this.showerHandler;

      this.shower = new Shower({
        target,
        handler,
        easing: 'ease',
        duration: 350,
        initOpened: false,
        openClassName: 'is-open',
      });
    }
  };

  jumpToTitle = button => {
    const target = button.dataset.to;
    const id = `#${target}`;

    if ($(id)) {
      console.log('$(id) :>> ', $(id));
      const topPosition = getTopPosition($(id));
      console.log('topPosition :>> ', topPosition);
      console.log('topPosition - this.offset :>> ', topPosition - this.offset);
      AniScroll(topPosition - this.offset, 1000, 'easeOutQuad', () => {
        // safari .focus() bug if browser is not safari or is not safari und chrome
        // Chrome: "Mozilla/5.0 (Macintosh; Intel Mac OS X 11_2_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.82 Safari/537.36"
        if (
          navigator.userAgent.indexOf('Safari') < 0 ||
          (navigator.userAgent.indexOf('Safari') > 0 &&
            navigator.userAgent.indexOf('Chrome') > 0)
        ) {
          $(id).setAttribute('tabindex', '0');
          $(id).focus();
        }
        this.setUrlHash(id);
      });
    } else {
      console.error(`target element ${id} does not exists`);
    }
  };

  setUrlHash = id => {
    if (history.pushState) {
      history.pushState(null, null, id);
    } else {
      window.location.hash = id;
    }
  };

  getAllJumpmarkTargets = () => {
    const targets = [];
    this.itemsButtons.forEach(button => {
      const target = $(`#${button.dataset.to}`);
      target && targets.push(target);
    });
    return targets;
  };

  checkScrollPosition = targets => {
    const doc = document.documentElement;
    const windowTop =
      (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    targets.forEach((target, index) => {
      const button = $(`[data-to="${target.id}"]`);
      const nextTarget = targets[index + 1];

      /* check if windowScrollPosition is above AND below the next target
        if yes, the target should get active. If not, then not.
        If there is now nextTarget (because its the last item in array), dont bother asking for that part
      */
      if (nextTarget) {
        if (
          windowTop >= target.offsetTop - this.offset &&
          windowTop < nextTarget.offsetTop - this.offset
        ) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      } else {
        if (windowTop >= target.offsetTop - this.offset) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      }
    });
  };

  bindEvents = () => {
    this.itemsButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.itemsButtons.forEach(button =>
          button.classList.remove('is-active')
        );
        this.jumpToTitle(button);
        button.classList.add('is-active');
        if (this.showerAlreadyInited) {
          this.shower.close();
        }
      });
    });
  };

  init = () => {
    this.initShower();
    if (this.doprdown) {
      this.toggleDropdown();
      Bus.subscribe('resize', 'jumpmarks', this.toggleDropdown);
    }
    this.bindEvents();

    if (this.detectScroll) {
      const targets = this.getAllJumpmarkTargets();
      Bus.subscribe('scroll', 'jumpmarks-scroll', () =>
        this.checkScrollPosition(targets)
      );
    }
  };
}

const jumpmarks = $$('.jumpmarks');

jumpmarks.length &&
  jumpmarks.forEach(jumpmark => {
    new Jumpmarks({
      container: jumpmark, // die gesamte section des elements
      target: $('.jumpmarks__box', jumpmark), // inner wrapper
      itemsButtons: $$('.jumpmarks__button', jumpmark), // button
      detectScroll: false,
      offset: 90,
    }).init();
  });
